<app-modal
  *ngIf="mainContent && secondaryAction && primaryAction"
  [modalTitle]="'general.investmentQualification'"
  [mainContentTemplate]="mainContent"
  [secondaryActionTemplate]="secondaryAction"
  [primaryActionTemplate]="primaryAction"
  (closed)="activeModal.dismiss()"
></app-modal>

<ng-template #mainContent>
  <label class="mb-2"
    >{{
      "registrationWizard.investorRatingModal.experienceDetermination.description"
        | translate
    }}
  </label>
  <label class="mb-0"
    >{{
      "registrationWizard.investorRatingModal.experienceDetermination.info"
        | translate
    }}
  </label>
  <form [formGroup]="expDeterminationForm">
    <div class="row flex-between-center">
      <app-validated-checkbox
        [inputFormControl]="expDeterminationForm.controls.minGrossIncome"
        inputFormControlName="minGrossIncome"
        label="registrationWizard.investorRatingModal.experienceDetermination.minGrossIncome"
      >
      </app-validated-checkbox>

      <app-validated-checkbox
        [inputFormControl]="expDeterminationForm.controls.atLeastOneYerExp"
        inputFormControlName="atLeastOneYerExp"
        label="registrationWizard.investorRatingModal.experienceDetermination.atLeastOneYerExp"
      >
      </app-validated-checkbox>

      <app-validated-checkbox
        [inputFormControl]="expDeterminationForm.controls.experienced"
        inputFormControlName="experienced"
        label="registrationWizard.investorRatingModal.experienceDetermination.experienced"
      >
      </app-validated-checkbox>

      <app-validated-checkbox
        [inputFormControl]="expDeterminationForm.controls.validStatements"
        inputFormControlName="validStatements"
        label="general.validStatements"
      >
      </app-validated-checkbox>
    </div>
  </form>
</ng-template>

<ng-template #secondaryAction>
  <button
    class="btn btn-falcon-default btn-sm me-3"
    type="button"
    (click)="handleSecondaryAction()"
  >
    {{ "general.cancel" | translate }}
  </button>
</ng-template>

<ng-template #primaryAction>
  <button
    class="btn btn-primary btn-sm"
    type="submit"
    (click)="handlePrimaryAction()"
  >
    {{ "general.next" | translate
    }}<span class="fas fa-chevron-right ms-2" data-fa-transform="shrink-3">
    </span>
  </button>
</ng-template>
